//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "StatementPDFV3",

  props: {
    main_data: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      pdfMakeReady: false,
      dataMode: "single", // "single" = 1 หน้า, "multiple" = หลายหน้า
      // ข้อมูลจำลอง 1 หน้า (8 รายการ)
      singlePageData: {
        datashowAll: [
          [
            {
              report_type: "SO",
              report_desc:
                'การจดทะเบียนเครื่องหมายการค้า "SUNMUM & Device" ในจำพวก 16 ในประเทศแคนาดา\nเลขที่อ้างอิงเอกสาร: TM-18915(A)',
              report_amount: 15000,
              no: 1,
            },
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการตรวจสอบหนังสือสำคัญการจดทะเบียน และรายงานเรื่องดังกล่าวแก่ท่าน",
              report_amount: 16730,
              no: 2,
            },
            {
              report_type: "SO",
              report_desc:
                'การจดทะเบียนสิทธิบัตร "Smart Home System" ในประเทศสหรัฐอเมริกา\nรวมถึงการตรวจสอบความซ้ำซ้อนและการวิเคราะห์ความเป็นไปได้ทางเทคนิค\nเลขที่อ้างอิงเอกสาร: PT-29847(B)',
              report_amount: 25000,
              no: 3,
            },
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการยื่นคำขอต่ออายุเครื่องหมายการค้าในประเทศญี่ปุ่น\nเลขที่อ้างอิงเอกสาร: TM-19234(C)",
              report_amount: 0,
              no: 4,
            },
            {
              report_type: "SO",
              report_desc:
                "การให้คำปรึกษาทางกฎหมายเกี่ยวกับการละเมิดลิขสิทธิ์ซอฟต์แวร์",
              report_amount: 22000,
              no: 5,
            },
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการจดทะเบียนลิขสิทธิ์ซอฟต์แวร์ในประเทศไทย\nเลขที่อ้างอิงเอกสาร: SW-45678(D)",
              report_amount: 12000,
              no: 6,
            },
            {
              report_type: "SO",
              report_desc:
                "การตรวจสอบสถานะการจดทะเบียนเครื่องหมายการค้าในสหภาพยุโรป\nรวมถึงการวิเคราะห์ความเสี่ยงและการให้คำแนะนำเชิงกลยุทธ์\nเลขที่อ้างอิงเอกสาร: TM-23456(E)",
              report_amount: 0,
              no: 7,
            },
            {
              report_type: "ADMIS",
              report_desc:
                "ค่าส่งไปรษณีย์, ค่าถ่ายเอกสาร, ค่าธรรมเนียมธนาคาร และค่าบริการอื่นๆ",
              report_amount: 3574,
              no: 8,
            },
          ],
        ],
        print_header: {
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_title: "STATEMENT",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: 'TAX ID. No. 0105534015348/"HEAD OFFICE"',
          docref: "REF-2025-001",
          attention: "Account Department",
          inv_id: "25100027",
          customer_name: "Beyond Attorneys at Law",
          invoice_date: "03/10/2025",
          addressall:
            "F6,Xijin Centre,39 Lianhuachi East Rd.,\nBeijing\n,\n100036\nChina",
          customer_address:
            "F6,Xijin Centre,39 Lianhuachi East Rd., Beijing 100036",
          period_cover: "January - March 2025",
          customer_taxid: "91110000MA01234567",
          sub_total: 94304,
          wth_rate: "3.00",
          tax_rate: "7.00",
          wth_rate_amount: 2829.12,
          tax_rate_amount: 6601.28,
          amount_total: 98076.16,
        },
        showcurrency: "USD",
        textamount_total_en: "Ninety Eight Thousand Seventy Six Point Sixteen",
      },
      // ข้อมูลจำลองสำหรับทดสอบ (หลายหน้า)
      multiplePageData: {
        datashowAll: [
          [
            // รายการที่ 1 - 2 บรรทัด
            {
              report_type: "SO",
              report_desc:
                'การจดทะเบียนเครื่องหมายการค้า "SUNMUM & Device" ในจำพวก 16 ในประเทศแคนาดา\nเลขที่อ้างอิงเอกสาร: TM-18915(A)',
              report_amount: 15000,
              no: 1,
            },
            // รายการที่ 2 - 1 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการตรวจสอบหนังสือสำคัญการจดทะเบียน และรายงานเรื่องดังกล่าวแก่ท่าน",
              report_amount: 16730,
              no: 2,
            },
            // รายการที่ 3 - 3 บรรทัด
            {
              report_type: "SO",
              report_desc:
                'การจดทะเบียนสิทธิบัตร "Smart Home System" ในประเทศสหรัฐอเมริกา\nรวมถึงการตรวจสอบความซ้ำซ้อนและการวิเคราะห์ความเป็นไปได้ทางเทคนิค\nเลขที่อ้างอิงเอกสาร: PT-29847(B)',
              report_amount: 25000,
              no: 3,
            },
            // รายการที่ 4 - 2 บรรทัด, ไม่มี amount
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการยื่นคำขอต่ออายุเครื่องหมายการค้าในประเทศญี่ปุ่น\nเลขที่อ้างอิงเอกสาร: TM-19234(C)",
              report_amount: 0,
              no: 4,
            },
            // รายการที่ 5 - 1 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "การให้คำปรึกษาทางกฎหมายเกี่ยวกับการละเมิดลิขสิทธิ์ซอฟต์แวร์",
              report_amount: 22000,
              no: 5,
            },
            // รายการที่ 6 - 2 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการจดทะเบียนลิขสิทธิ์ซอฟต์แวร์ในประเทศไทย\nเลขที่อ้างอิงเอกสาร: SW-45678(D)",
              report_amount: 12000,
              no: 6,
            },
            // รายการที่ 7 - 3 บรรทัด, ไม่มี amount
            {
              report_type: "SO",
              report_desc:
                "การตรวจสอบสถานะการจดทะเบียนเครื่องหมายการค้าในสหภาพยุโรป\nรวมถึงการวิเคราะห์ความเสี่ยงและการให้คำแนะนำเชิงกลยุทธ์\nเลขที่อ้างอิงเอกสาร: TM-23456(E)",
              report_amount: 0,
              no: 7,
            },
            // รายการที่ 8 - 1 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการยื่นคำคัดค้านเครื่องหมายการค้าในประเทศเกาหลีใต้",
              report_amount: 28000,
              no: 8,
            },
            // รายการที่ 9 - 2 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "การให้คำปรึกษาเกี่ยวกับการคุ้มครองความลับทางการค้าและทรัพย์สินทางปัญญา\nเลขที่อ้างอิงเอกสาร: TS-56789(G)",
              report_amount: 15500,
              no: 9,
            },
            // รายการที่ 10 - 3 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการจดทะเบียนแบบผลิตภัณฑ์ในประเทศจีน\nรวมถึงการประสานงานกับหน่วยงานราชการและการติดตามผลการดำเนินการ\nเลขที่อ้างอิงเอกสาร: DS-67890(H)",
              report_amount: 16500,
              no: 10,
            },
            // รายการที่ 11 - 1 บรรทัด, ไม่มี amount
            {
              report_type: "SO",
              report_desc:
                "การตรวจสอบและวิเคราะห์ความเสี่ยงด้านทรัพย์สินทางปัญญา",
              report_amount: 0,
              no: 11,
            },
            // รายการที่ 12 - 2 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการยื่นคำขอจดทะเบียนสิทธิบัตรในประเทศออสเตรเลีย\nเลขที่อ้างอิงเอกสาร: PT-89012(J)",
              report_amount: 27500,
              no: 12,
            },
            // รายการที่ 13 - 3 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "การให้คำปรึกษาเกี่ยวกับสัญญาการโอนเทคโนโลยี\nรวมถึงการจัดทำร่างสัญญาและการเจรจาต่อรองเงื่อนไขทางธุรกิจ\nเลขที่อ้างอิงเอกสาร: TT-90123(K)",
              report_amount: 21000,
              no: 13,
            },
            // รายการที่ 14 - 1 บรรทัด
            {
              report_type: "SO",
              report_desc: "ดำเนินการจดทะเบียนชื่อโดเมนและคุ้มครองทางกฎหมาย",
              report_amount: 13500,
              no: 14,
            },
            // รายการที่ 15 - 2 บรรทัด, ไม่มี amount
            {
              report_type: "SO",
              report_desc:
                "การตรวจสอบการละเมิดเครื่องหมายการค้าในตลาดออนไลน์\nเลขที่อ้างอิงเอกสาร: TM-12345(M)",
              report_amount: 0,
              no: 15,
            },
            // รายการที่ 16 - 2 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "การให้คำปรึกษาด้านกลยุทธ์การจัดการพอร์ตโฟลิโอทรัพย์สินทางปัญญา\nเลขที่อ้างอิงเอกสาร: IP-23456(N)",
              report_amount: 18900,
              no: 16,
            },
            // รายการที่ 17 - 3 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการยื่นคำขอจดทะเบียนเครื่องหมายบริการในประเทศสิงคโปร์\nรวมถึงการตรวจค้นเบื้องต้นและการวิเคราะห์โอกาสความสำเร็จ\nเลขที่อ้างอิงเอกสาร: SM-34567(O)",
              report_amount: 19200,
              no: 17,
            },
            // รายการที่ 18 - 1 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "การจัดทำข้อตกลงการไม่เปิดเผยข้อมูล (NDA) สำหรับโครงการวิจัยและพัฒนา",
              report_amount: 8500,
              no: 18,
            },
            // รายการที่ 19 - 2 บรรทัด, ไม่มี amount
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการต่ออายุการจดทะเบียนสิทธิบัตรในประเทศญี่ปุ่น\nเลขที่อ้างอิงเอกสาร: PT-45678(P)",
              report_amount: 0,
              no: 19,
            },
            // รายการที่ 20 - 3 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "การให้คำปรึกษาเกี่ยวกับการคุ้มครองลิขสิทธิ์ในสื่อดิจิทัล\nรวมถึงการวิเคราะห์กรณีการละเมิดและการดำเนินการทางกฎหมาย\nเลขที่อ้างอิงเอกสาร: CR-56789(Q)",
              report_amount: 23400,
              no: 20,
            },
            // รายการที่ 21 - 1 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "การตรวจสอบความถูกต้องของเอกสารการจดทะเบียนทรัพย์สินทางปัญญา",
              report_amount: 9800,
              no: 21,
            },
            // รายการที่ 22 - 2 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการยื่นคำคัดค้านการจดทะเบียนสิทธิบัตรในยุโรป\nเลขที่อ้างอิงเอกสาร: PT-67890(R)",
              report_amount: 31500,
              no: 22,
            },
            // รายการที่ 23 - 3 บรรทัด, ไม่มี amount
            {
              report_type: "SO",
              report_desc:
                "การให้คำปรึกษาเกี่ยวกับการใช้ประโยชน์เชิงพาณิชย์จากทรัพย์สินทางปัญญา\nรวมถึงการวางแผนกลยุทธ์การตลาดและการจัดหาพันธมิตรทางธุรกิจ\nเลขที่อ้างอิงเอกสาร: CM-78901(S)",
              report_amount: 0,
              no: 23,
            },
            // รายการที่ 24 - 2 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการจดทะเบียนเครื่องหมายร่วม (Collective Mark) ในประเทศไทย\nเลขที่อ้างอิงเอกสาร: TM-89012(T)",
              report_amount: 14200,
              no: 24,
            },
            // รายการที่ 25 - 1 บรรทัด
            {
              report_type: "SO",
              report_desc: "การจัดทำรายงานการประเมินมูลค่าทรัพย์สินทางปัญญา",
              report_amount: 26800,
              no: 25,
            },
            // รายการที่ 26 - 3 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "การให้คำปรึกษาเกี่ยวกับการจัดการลิขสิทธิ์สำหรับงานสร้างสรรค์\nรวมถึงการจัดทำสัญญาอนุญาตให้ใช้สิทธิและการเจรจาค่าตอบแทน\nเลขที่อ้างอิงเอกสาร: CR-90123(U)",
              report_amount: 17600,
              no: 26,
            },
            // รายการที่ 27 - 2 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการยื่นขอจดทะเบียนแบบผังผลิตภัณฑ์สารกึ่งตัวนำ\nเลขที่อ้างอิงเอกสาร: IC-01234(V)",
              report_amount: 29300,
              no: 27,
            },
            // รายการที่ 28 - 1 บรรทัด, ไม่มี amount
            {
              report_type: "SO",
              report_desc:
                "การตรวจสอบสถานะและความครอบคลุมของการคุ้มครองทรัพย์สินทางปัญญา",
              report_amount: 0,
              no: 28,
            },
            // รายการที่ 29 - 2 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "การให้คำปรึกษาด้านกฎหมายเกี่ยวกับการใช้เครื่องหมายการค้าในสื่อสังคมออนไลน์\nเลขที่อ้างอิงเอกสาร: SM-12345(W)",
              report_amount: 11700,
              no: 29,
            },
            // รายการที่ 30 - 3 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการจดทะเบียนสิทธิบัตรการออกแบบผลิตภัณฑ์ในประเทศจีน\nรวมถึงการประสานงานกับผู้เชี่ยวชาญด้านเทคนิคและการจัดทำเอกสารประกอบ\nเลขที่อ้างอิงเอกสาร: DP-23456(X)",
              report_amount: 22100,
              no: 30,
            },
            // รายการที่ 31 - 1 บรรทัด
            {
              report_type: "SO",
              report_desc: "การจัดทำสัญญาการโอนสิทธิในทรัพย์สินทางปัญญา",
              report_amount: 13900,
              no: 31,
            },
            // รายการที่ 32 - 2 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "การให้คำปรึกษาเกี่ยวกับการป้องกันการละเมิดทรัพย์สินทางปัญญาในตลาดโลก\nเลขที่อ้างอิงเอกสาร: GL-34567(Y)",
              report_amount: 24500,
              no: 32,
            },
            // รายการที่ 33 - 3 บรรทัด, ไม่มี amount
            {
              report_type: "SO",
              report_desc:
                "ดำเนินการขอจดทะเบียนเครื่องหมายรับรองคุณภาพสินค้า\nรวมถึงการจัดทำระเบียบการใช้เครื่องหมายและการกำกับดูแล\nเลขที่อ้างอิงเอกสาร: CM-45678(Z)",
              report_amount: 0,
              no: 33,
            },
            // รายการที่ 34 - 2 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "การตรวจสอบและวิเคราะห์พอร์ตโฟลิโอสิทธิบัตรของคู่แข่งทางธุรกิจ\nเลขที่อ้างอิงเอกสาร: CI-56789(AA)",
              report_amount: 19800,
              no: 34,
            },
            // รายการที่ 35 - 1 บรรทัด
            {
              report_type: "SO",
              report_desc:
                "การให้คำปรึกษาด้านการคุ้มครองทรัพย์สินทางปัญญาสำหรับธุรกิจสตาร์ทอัพ",
              report_amount: 15300,
              no: 35,
            },
            // รายการสุดท้าย - Administrative
            {
              report_type: "ADMIS",
              report_desc:
                "ค่าส่งไปรษณีย์, ค่าถ่ายเอกสาร, ค่าธรรมเนียมธนาคาร และค่าบริการอื่นๆ",
              report_amount: 3574,
              no: 36,
            },
          ],
        ],
        print_header: {
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_title: "STATEMENT",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: 'TAX ID. No. 0105534015348/"HEAD OFFICE"',
          docref: "REF-2025-001",
          attention: "Account Department",
          inv_id: "25100027",
          customer_name: "Beyond Attorneys at Law",
          invoice_date: "03/10/2025",
          addressall:
            "F6,Xijin Centre,39 Lianhuachi East Rd.,\nBeijing\n,\n100036\nChina",
          customer_address:
            "F6,Xijin Centre,39 Lianhuachi East Rd., Beijing 100036",
          period_cover: "January - March 2025",
          customer_taxid: "91110000MA01234567",
          sub_total: 297600,
          wth_rate: "3.00",
          tax_rate: "7.00",
          wth_rate_amount: 8928.0,
          tax_rate_amount: 20832.0,
          amount_total: 309504.0,
        },
        showcurrency: "USD",
        textamount_total_en:
          "Three Hundred Nine Thousand Five Hundred Four Point Zero Zero",
      },
    };
  },

  computed: {
    // เลือกข้อมูลตาม mode
    mockData() {
      return this.dataMode === "single"
        ? this.singlePageData
        : this.multiplePageData;
    },

    statementData() {
      return this.main_data || this.mockData;
    },

    // คำนวณ itemsPerPage แบบไดนามิก
    dynamicItemsPerPage() {
      const totalItems = this.items.length;
      // ถ้าไม่เกิน 8 บรรทัด ใช้ 8, ถ้ามากกว่าใช้ 13
      return totalItems <= 8 ? 8 : 13;
    },

    header() {
      return this.statementData.print_header || {};
    },

    items() {
      if (
        this.statementData.datashowAll &&
        this.statementData.datashowAll.length > 0
      ) {
        return this.statementData.datashowAll[0] || [];
      }
      return [];
    },

    subtotal() {
      return this.header.sub_total || 0;
    },

    withholdingTax() {
      return this.header.wth_rate_amount || 0;
    },

    vat() {
      return this.header.tax_rate_amount || 0;
    },

    grandTotal() {
      return this.header.amount_total || 0;
    },

    withholdingTaxRate() {
      return this.header.wth_rate || "3.00";
    },

    vatRate() {
      return this.header.tax_rate || "7.00";
    },

    currency() {
      return this.statementData.showcurrency || "USD";
    },
  },

  mounted() {
    this.waitForPdfMake();
    if (this.$hideLoader) {
      this.$hideLoader();
    }
  },

  methods: {
    waitForPdfMake() {
      const checkInterval = setInterval(() => {
        if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
          this.pdfMakeReady = true;
          clearInterval(checkInterval);
          console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkInterval);
        if (!this.pdfMakeReady) {
          console.error("❌ pdfMake โหลดไม่สำเร็จ");
          alert(
            "ไม่สามารถโหลดระบบ PDF ได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต"
          );
        }
      }, 10000);
    },

    formatNumber(value) {
      if (!value && value !== 0) return "0.00";
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },

    formatDate(dateString) {
      if (!dateString) return "";
      if (dateString.includes("/")) {
        return dateString;
      }

      const date = new Date(dateString);
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    // ฟังก์ชันสร้างส่วนผลรวมและ footer (ใช้เฉพาะหน้าสุดท้าย)
    generateSummaryAndFooter() {
      return [
        // ตารางสรุปยอดเงิน
        {
          table: {
            widths: ["*", 120],
            body: [
              [
                {
                  text: "Sub Total / รวมเป็นเงิน",
                  fontSize: 10,
                  border: [true, true, true, false],
                  margin: [5, 3, 5, 3],
                },
                {
                  text: this.formatNumber(this.subtotal),
                  fontSize: 10,
                  alignment: "right",
                  border: [true, true, true, false],
                  margin: [5, 3, 5, 3],
                },
              ],
              [
                {
                  text: `Less Withholding Tax / ภาษีหัก ณ ที่จ่าย (${this.withholdingTaxRate}%)`,
                  fontSize: 10,
                  border: [true, false, true, false],
                  margin: [5, 3, 5, 3],
                },
                {
                  text: this.formatNumber(this.withholdingTax),
                  fontSize: 10,
                  alignment: "right",
                  border: [true, false, true, false],
                  margin: [5, 3, 5, 3],
                },
              ],
              [
                {
                  text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${this.vatRate}%)`,
                  fontSize: 10,
                  border: [true, false, true, false],
                  margin: [5, 3, 5, 3],
                },
                {
                  text: this.formatNumber(this.vat),
                  fontSize: 10,
                  alignment: "right",
                  border: [true, false, true, false],
                  margin: [5, 3, 5, 3],
                },
              ],
              [
                {
                  text: "Grand Total / ยอดรวม",
                  fontSize: 10,
                  bold: true,
                  border: [true, false, true, true],
                  margin: [5, 3, 5, 3],
                },
                {
                  text: this.formatNumber(this.grandTotal),
                  fontSize: 10,
                  bold: true,
                  alignment: "right",
                  border: [true, false, true, true],
                  margin: [5, 3, 5, 3],
                },
              ],
            ],
          },
          layout: {
            paddingLeft: function() {
              return 0;
            },
            paddingRight: function() {
              return 0;
            },
            paddingTop: function() {
              return 0;
            },
            paddingBottom: function() {
              return 0;
            },
          },
          margin: [0, 0, 0, 5],
        },

        // จำนวนเงินตัวอักษร
        {
          text: `(${this.statementData.textamount_total_en || ""}) ${
            this.currency
          }`,
          fontSize: 10,
          bold: true,
          alignment: "center",
          margin: [0, 5, 0, 10],
        },

        // ข้อความ Please send
        {
          stack: [
            {
              text:
                "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
              fontSize: 8,
              alignment: "center",
              margin: [0, 0, 0, 1],
            },
            {
              text:
                "โปรดส่งหนังสือรับรองการหักภาษีณ ที่จ่ายมาพร้อมกับเอกสารชำระเงิน",
              fontSize: 8,
              alignment: "center",
              margin: [0, 0, 0, 10],
            },
          ],
        },

        // Disclaimer
        {
          stack: [
            {
              text: "Cybersecurity & Wire Transfer Disclaimer",
              fontSize: 8,
              bold: true,
              color: "red",
              margin: [0, 0, 0, 2],
            },
            {
              text:
                "Dej-Udom & Associates shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must be independently verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates for verification if in doubt.",
              fontSize: 7,
              color: "red",
              alignment: "justify",
            },
          ],
        },
      ];
    },

    generateMainStatement(documentType = "ORIGINAL") {
      const mainContent = [];
      const itemsPerPage = this.dynamicItemsPerPage; // ใช้ค่าแบบไดนามิก

      // ===== หน้าที่ 1 =====
      mainContent.push(
        // Header บริษัท
        {
          columns: [
            {
              width: "50%",
              stack: [
                {
                  text: this.header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.",
                  fontSize: 16,
                  bold: true,
                  margin: [0, 0, 0, 1],
                },
                {
                  text: this.header.com_eng_2 || "ATTORNEYS AT LAW",
                  fontSize: 9,
                  margin: [0, 0, 0, 2],
                },
                {
                  text:
                    this.header.com_thai ||
                    "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                  fontSize: 11,
                  margin: [0, 0, 0, 1],
                },
              ],
            },
            {
              width: "50%",
              stack: [
                {
                  text:
                    this.header.com_add_name ||
                    "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text: this.header.com_add_no || "942/69 RAMA IV ROAD,",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    this.header.com_add_city ||
                    "KWAENG SURIYAWONG, KHET BANGRAK,",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    this.header.com_add_country || "BANGKOK 10500, THAILAND",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    this.header.com_add_tel || "Tel : 0-2233-0055, 0-2267-5152",
                  fontSize: 8,
                  alignment: "right",
                  margin: [0, 2, 0, 0],
                },
                {
                  text:
                    this.header.com_add_email || "E-MAIL : account@dejudom.com",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    this.header.com_add_tax_id ||
                    'TAX ID. No. 0105534015348/"HEAD OFFICE"',
                  fontSize: 8,
                  alignment: "right",
                  bold: true,
                },
              ],
            },
          ],
          margin: [0, 0, 0, 15],
        },

        // STATEMENT พร้อม ORIGINAL/COPY
        {
          columns: [
            {
              width: "70%",
              text: this.header.com_title || "STATEMENT",
              fontSize: 18,
              bold: true,
            },
            {
              width: "30%",
              stack: [
                {
                  text: documentType,
                  fontSize: 11,
                  bold: true,
                  alignment: "right",
                  margin: [0, 0, 0, 2],
                },
                {
                  text: `No. / เลขที่ : ${this.header.inv_id || ""}`,
                  fontSize: 10,
                  alignment: "right",
                },
              ],
            },
          ],
          margin: [0, 0, 0, 5],
        },

        // เส้นคั่น
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 515,
              y2: 0,
              lineWidth: 1,
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // ข้อมูลลูกค้า
        {
          columns: [
            {
              width: "55%",
              stack: [
                {
                  text: [
                    { text: "To / ถึง:  ", fontSize: 10 },
                    {
                      text: this.header.customer_name || "",
                      fontSize: 10,
                      bold: true,
                    },
                  ],
                  margin: [0, 0, 0, 2],
                },
                {
                  text: (this.header.addressall || "").split("\n"),
                  fontSize: 9,
                  margin: [0, 0, 0, 5],
                },
                {
                  text: `Tax ID: ${this.header.customer_taxid || "0"}`,
                  fontSize: 9,
                  margin: [0, 3, 0, 2],
                },
                {
                  text: `Attention : ${this.header.attention ||
                    this.header.customer_contact_name ||
                    "-"}`,
                  fontSize: 9,
                },
              ],
            },
            {
              width: "45%",
              stack: [
                {
                  text: `Date / วันที่: ${this.formatDate(
                    this.header.invoice_date
                  )}`,
                  fontSize: 9,
                  alignment: "right",
                  margin: [0, 0, 0, 8],
                },
                {
                  text: `Period Covered / รอบระยะเวลา : ${this.header
                    .period_cover || "-"}`,
                  fontSize: 9,
                  alignment: "right",
                  margin: [0, 0, 0, 2],
                },
                {
                  text: `Document Ref. : ${this.header.docref || "-"}`,
                  fontSize: 9,
                  alignment: "right",
                },
              ],
            },
          ],
          margin: [0, 0, 0, 15],
        },

        // ตาราง หน้า 1 - มีความสูงคงที่ 9 แถว
        {
          table: {
            headerRows: 1,
            widths: ["*", 120],
            heights: (row) => {
              if (row === 0) return "auto"; // header
              return 32; // กำหนดความสูงแต่ละแถว 32pt (ประมาณ 2-3 บรรทัด)
            },
            body: (() => {
              const tableBody = [
                [
                  {
                    text: "Description / รายการ",
                    fontSize: 10,
                    bold: true,
                    margin: [5, 5, 5, 5],
                  },
                  {
                    text: "Amount / จำนวนเงิน",
                    fontSize: 10,
                    bold: true,
                    alignment: "right",
                    margin: [5, 5, 5, 5],
                  },
                ],
              ];

              // เพิ่มรายการจริงจาก items หรือแถวว่างถ้าไม่พอ 9 แถว
              for (let i = 0; i < itemsPerPage; i++) {
                if (i < this.items.length) {
                  const item = this.items[i];
                  tableBody.push([
                    {
                      text: item.report_desc || "",
                      fontSize: 9,
                      margin: [5, 5, 5, 5],
                    },
                    {
                      text:
                        item.report_amount && item.report_amount !== 0
                          ? this.formatNumber(item.report_amount)
                          : "",
                      fontSize: 9,
                      alignment: "right",
                      margin: [5, 5, 5, 5],
                    },
                  ]);
                } else {
                  // แถวว่าง
                  tableBody.push([
                    {
                      text: "",
                      fontSize: 9,
                      margin: [5, 5, 5, 5],
                    },
                    {
                      text: "",
                      fontSize: 9,
                      alignment: "right",
                      margin: [5, 5, 5, 5],
                    },
                  ]);
                }
              }

              // เพิ่มแถว IMPORTANT ติดล่างสุดของตาราง
              tableBody.push([
                {
                  text:
                    "IMPORTANT: Payment must be paid in full, without deductions of foreign bank fees or taxes;\nwe will solely be responsible for Thai tax.",
                  fontSize: 8,
                  italics: true,
                  bold: true,
                  margin: [5, 5, 5, 5],
                },
                {},
              ]);

              return tableBody;
            })(),
          },
          layout: {
            hLineWidth: function(i, node) {
              // แสดงเส้นบนสุด (i=0), เส้นใต้ header (i=1), และเส้นล่างสุด
              if (i === 0 || i === 1 || i === node.table.body.length) {
                return 1;
              }
              return 0;
            },
            vLineWidth: function(i) {
              return 1;
            },
            paddingLeft: function() {
              return 0;
            },
            paddingRight: function() {
              return 0;
            },
            paddingTop: function() {
              return 0;
            },
            paddingBottom: function() {
              return 0;
            },
          },
          margin: [0, 0, 0, 0],
        }
      );

      // ===== หน้าที่ 2+ ของ Statement (ถ้ามีข้อมูลเกิน 15 รายการ) =====
      const remainingItems = this.items.length - itemsPerPage;

      if (remainingItems > 0) {
        const itemsPerContinuedPage = 20; // ลดจาก 25 เป็น 20 เพื่อไม่ให้เกินกระดาษ
        const additionalPages = Math.ceil(
          remainingItems / itemsPerContinuedPage
        );

        for (let page = 0; page < additionalPages; page++) {
          const startIdx = itemsPerPage + page * itemsPerContinuedPage;
          const endIdx = Math.min(
            startIdx + itemsPerContinuedPage,
            this.items.length
          );
          const isLastPage = endIdx === this.items.length;

          mainContent.push(
            { text: "", pageBreak: "before" },

            {
              text: "STATEMENT (Continued)",
              fontSize: 16,
              bold: true,
              margin: [0, 0, 0, 15],
            },

            {
              table: {
                headerRows: 1,
                widths: ["*", 120],
                body: [
                  [
                    {
                      text: "Description / รายการ",
                      fontSize: 10,
                      bold: true,
                      margin: [5, 5, 5, 5],
                    },
                    {
                      text: "Amount / จำนวนเงิน",
                      fontSize: 10,
                      bold: true,
                      alignment: "right",
                      margin: [5, 5, 5, 5],
                    },
                  ],
                  ...this.items.slice(startIdx, endIdx).map((item) => [
                    {
                      text: item.report_desc || "",
                      fontSize: 9,
                      margin: [5, 5, 5, 5],
                    },
                    {
                      text:
                        item.report_amount && item.report_amount !== 0
                          ? this.formatNumber(item.report_amount)
                          : "",
                      fontSize: 9,
                      alignment: "right",
                      margin: [5, 5, 5, 5],
                    },
                  ]),
                ],
              },
              layout: {
                hLineWidth: function(i, node) {
                  // แสดงเส้นบนสุด, เส้นใต้ header, และเส้นล่างสุด
                  if (i === 0 || i === 1 || i === node.table.body.length) {
                    return 1;
                  }
                  return 0;
                },
                vLineWidth: function(i) {
                  return 1;
                },
                paddingLeft: function() {
                  return 0;
                },
                paddingRight: function() {
                  return 0;
                },
                paddingTop: function() {
                  return 0;
                },
                paddingBottom: function() {
                  return 0;
                },
              },
              margin: [0, 0, 0, isLastPage ? 0 : 0],
            }
          );

          // *** ถ้าเป็นหน้าสุดท้าย ให้เพิ่มผลรวมและ footer ***
          if (isLastPage) {
            mainContent.push(
              // สรุปยอดเงิน
              {
                table: {
                  widths: ["*", 120],
                  body: [
                    [
                      {
                        text: "Sub Total / รวมเป็นเงิน",
                        fontSize: 10,
                        border: [true, true, true, false],
                        margin: [5, 3, 5, 3],
                      },
                      {
                        text: this.formatNumber(this.subtotal),
                        fontSize: 10,
                        alignment: "right",
                        border: [true, true, true, false],
                        margin: [5, 3, 5, 3],
                      },
                    ],
                    [
                      {
                        text: `Less Withholding Tax / ภาษีเงินได้หัก ณ ที่จ่าย (${this.withholdingTaxRate}%)`,
                        fontSize: 10,
                        border: [true, false, true, false],
                        margin: [5, 3, 5, 3],
                      },
                      {
                        text: this.formatNumber(this.withholdingTax),
                        fontSize: 10,
                        alignment: "right",
                        border: [true, false, true, false],
                        margin: [5, 3, 5, 3],
                      },
                    ],
                    [
                      {
                        text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${this.vatRate}%)`,
                        fontSize: 10,
                        border: [true, false, true, false],
                        margin: [5, 3, 5, 3],
                      },
                      {
                        text: this.formatNumber(this.vat),
                        fontSize: 10,
                        alignment: "right",
                        border: [true, false, true, false],
                        margin: [5, 3, 5, 3],
                      },
                    ],
                    [
                      {
                        text: "Grand Total / ยอดรวม",
                        fontSize: 11,
                        bold: true,
                        fillColor: "#eeeeee",
                        border: [true, false, true, true],
                        margin: [5, 5, 5, 5],
                      },
                      {
                        text: this.formatNumber(this.grandTotal),
                        fontSize: 11,
                        bold: true,
                        alignment: "right",
                        fillColor: "#eeeeee",
                        border: [true, false, true, true],
                        margin: [5, 5, 5, 5],
                      },
                    ],
                  ],
                },
                layout: {
                  paddingLeft: function() {
                    return 0;
                  },
                  paddingRight: function() {
                    return 0;
                  },
                  paddingTop: function() {
                    return 0;
                  },
                  paddingBottom: function() {
                    return 0;
                  },
                },
                margin: [0, 0, 0, 5],
              },

              // จำนวนเงินตัวอักษร
              {
                text: `(${this.statementData.textamount_total_en || ""}) ${
                  this.currency
                }`,
                fontSize: 10,
                bold: true,
                alignment: "center",
                margin: [0, 5, 0, 10],
              },

              // ข้อความ Please send
              {
                stack: [
                  {
                    text:
                      "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
                    fontSize: 8,
                    alignment: "center",
                    margin: [0, 0, 0, 1],
                  },
                  {
                    text:
                      "โปรดส่งหนังสือรับรองการหักภาษีณ ที่จ่ายมาพร้อมกับเอกสารชำระเงิน",
                    fontSize: 8,
                    alignment: "center",
                    margin: [0, 0, 0, 10],
                  },
                ],
              },

              // Disclaimer
              {
                stack: [
                  {
                    text: "Cybersecurity & Wire Transfer Disclaimer",
                    fontSize: 8,
                    bold: true,
                    color: "red",
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text:
                      "Dej-Udom & Associates shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must be independently verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates for verification if in doubt.",
                    fontSize: 7,
                    color: "red",
                    alignment: "justify",
                  },
                ],
              }
            );
          }
        }
      } else {
        // *** ถ้ามีรายการไม่เกิน 9 รายการ ให้เพิ่มผลรวมและ footer ในหน้าแรก ***
        mainContent.push(
          // สรุปยอดเงิน หน้า 1
          {
            table: {
              widths: ["*", 120],
              body: [
                [
                  {
                    text: "Sub Total / รวมเป็นเงิน",
                    fontSize: 10,
                    border: [true, true, true, false],
                    margin: [5, 3, 5, 3],
                  },
                  {
                    text: this.formatNumber(this.subtotal),
                    fontSize: 10,
                    alignment: "right",
                    border: [true, true, true, false],
                    margin: [5, 3, 5, 3],
                  },
                ],
                [
                  {
                    text: `Less Withholding Tax / ภาษีเงินได้หัก ณ ที่จ่าย (${this.withholdingTaxRate}%)`,
                    fontSize: 10,
                    border: [true, false, true, false],
                    margin: [5, 3, 5, 3],
                  },
                  {
                    text: this.formatNumber(this.withholdingTax),
                    fontSize: 10,
                    alignment: "right",
                    border: [true, false, true, false],
                    margin: [5, 3, 5, 3],
                  },
                ],
                [
                  {
                    text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${this.vatRate}%)`,
                    fontSize: 10,
                    border: [true, false, true, false],
                    margin: [5, 3, 5, 3],
                  },
                  {
                    text: this.formatNumber(this.vat),
                    fontSize: 10,
                    alignment: "right",
                    border: [true, false, true, false],
                    margin: [5, 3, 5, 3],
                  },
                ],
                [
                  {
                    text: "Grand Total / ยอดรวม",
                    fontSize: 11,
                    bold: true,
                    fillColor: "#eeeeee",
                    border: [true, false, true, true],
                    margin: [5, 5, 5, 5],
                  },
                  {
                    text: this.formatNumber(this.grandTotal),
                    fontSize: 11,
                    bold: true,
                    alignment: "right",
                    fillColor: "#eeeeee",
                    border: [true, false, true, true],
                    margin: [5, 5, 5, 5],
                  },
                ],
              ],
            },
            layout: {
              paddingLeft: function() {
                return 0;
              },
              paddingRight: function() {
                return 0;
              },
              paddingTop: function() {
                return 0;
              },
              paddingBottom: function() {
                return 0;
              },
            },
            margin: [0, 0, 0, 5],
          },

          // จำนวนเงินตัวอักษร
          {
            text: `(${this.statementData.textamount_total_en || ""}) ${
              this.currency
            }`,
            fontSize: 10,
            bold: true,
            alignment: "center",
            margin: [0, 5, 0, 10],
          },

          // ข้อความ Please send
          {
            stack: [
              {
                text:
                  "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
                fontSize: 8,
                alignment: "center",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  "โปรดส่งหนังสือรับรองการหักภาษีณ ที่จ่ายมาพร้อมกับเอกสารชำระเงิน",
                fontSize: 8,
                alignment: "center",
                margin: [0, 0, 0, 10],
              },
            ],
          },

          // Disclaimer
          {
            stack: [
              {
                text: "Cybersecurity & Wire Transfer Disclaimer",
                fontSize: 8,
                bold: true,
                color: "red",
                margin: [0, 0, 0, 2],
              },
              {
                text:
                  "Dej-Udom & Associates shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must be independently verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates for verification if in doubt.",
                fontSize: 7,
                color: "red",
                alignment: "justify",
              },
            ],
          }
        );
      }

      return mainContent;
    },

    generateDocDefinition(documentType = "ORIGINAL") {
      const mainStatement = this.generateMainStatement(documentType);

      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 40, 40, 40],
        content: mainStatement,
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };

      return docDefinition;
    },

    // สร้าง PDF ที่มีทั้ง ORIGINAL และ COPY
    generateCombinedDocDefinition() {
      const originalContent = this.generateMainStatement("ORIGINAL");
      const copyContent = this.generateMainStatement("COPY");

      // เพิ่ม pageBreak ให้กับ COPY
      copyContent[0] = {
        ...copyContent[0],
        pageBreak: "before",
      };

      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 40, 40, 40],
        content: [...originalContent, ...copyContent],
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };

      return docDefinition;
    },

    previewPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = this.generateCombinedDocDefinition();
        pdfMake.createPdf(docDefinition).open();
        console.log("✅ เปิดตัวอย่าง PDF สำเร็จ (ORIGINAL + COPY)");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },

    downloadPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = this.generateCombinedDocDefinition();
        const fileName = `Statement_${this.header.inv_id || "document"}_${this
          .header.invoice_date || ""}.pdf`;
        pdfMake.createPdf(docDefinition).download(fileName);
        console.log("✅ ดาวน์โหลด PDF สำเร็จ (ORIGINAL + COPY)");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการดาวน์โหลด PDF: " + error.message);
      }
    },

    printPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = this.generateCombinedDocDefinition();
        pdfMake.createPdf(docDefinition).print();
        console.log("✅ สั่งพิมพ์ PDF สำเร็จ (ORIGINAL + COPY)");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการพิมพ์ PDF: " + error.message);
      }
    },
  },
};
